import { useMemo } from 'react';
import Link from './link';
import Header from './header';
import UptimeRobot from './uptimerobot';
import Package from '../../package.json';

function App() {

  const apikeys = useMemo(() => {
    const { ApiKeys } = window.Config;
    if (Array.isArray(ApiKeys)) return ApiKeys;
    if (typeof ApiKeys === 'string') return [ApiKeys];
    return [];
  }, []);

  return (
    <>
      <Header />
      <div className='container'>
        <div id='uptime'>
          {apikeys.map((key) => (
            <UptimeRobot key={key} apikey={key} />
          ))}
        </div>
        <div id='footer'>
          <p>Powered By&nbsp;<Link to='https://status.135353.xyz' text='Node Tech' />&nbsp;</p>
          <p>Copyright&nbsp;&copy;&nbsp;2023&nbsp;<Link to='https://status.135353.xyz' text='Node Status' />&nbsp;</p>
        </div>
      </div>
    </>
  );
}

export default App;
